import { render } from "./RestaurantForm.vue?vue&type=template&id=0dac77f4&scoped=true&ts=true"
import script from "./RestaurantForm.vue?vue&type=script&lang=ts"
export * from "./RestaurantForm.vue?vue&type=script&lang=ts"

import "./RestaurantForm.vue?vue&type=style&index=0&id=0dac77f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.35_vue@3.5.38_typescript@5.9.3__webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dac77f4"]])

export default __exports__